import Model from "./model";

const EMAIL_VERIFICAION_AUTH_TYPE_CD = {
  SIGN_UP: "0",
  RESET_PASSWORD: "1",
};

const EMAIL_VERIFICAION_STATUS_CD = {
  PENDING: "0",
  VERIFIED: "1",
};

class EmailVerification extends Model {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this._email;
    this._authTypeCd;
    this._statusCd;
    this._accessKey;
    this._authCode;
    this._authenticationId = null;
  }
  /* eslint-enable */

  get email() {
    return this._email;
  }

  set email(value) {
    this._email = value;
  }

  get authTypeCd() {
    return this._authTypeCd;
  }

  set authTypeCd(value) {
    this._authTypeCd = value;
  }

  get statusCd() {
    return this._statusCd;
  }

  set statusCd(value) {
    this._statusCd = value;
  }

  get accessKey() {
    return this._accessKey;
  }

  set accessKey(value) {
    this._accessKey = value;
  }

  get authCode() {
    return this._authCode;
  }

  set authCode(value) {
    this._authCode = value;
  }

  get authenticationId() {
    return this._authenticationId;
  }

  set authenticationId(value) {
    this._authenticationId = value;
  }

  copy() {
    const emailVerification = new EmailVerification();
    emailVerification.email = this.email;
    emailVerification.authTypeCd = this.authTypeCd;
    emailVerification.statusCd = this.statusCd;
    emailVerification.accessKey = this.accessKey;
    emailVerification.authCode = this.authCode;
    emailVerification.authenticationId = this.authenticationId;

    return emailVerification;
  }

  isVerified() {
    return this.authenticationId !== null;
  }
}

export {
  EmailVerification,
  EMAIL_VERIFICAION_AUTH_TYPE_CD,
  EMAIL_VERIFICAION_STATUS_CD,
};
